module.exports = __webpack_public_path__ + "static/media/Illustratiion@3x.45f6602f.png";